import React, { useEffect, useState } from 'react';
import './enrollment.css';
import HeroTwo from '../components/heroTwo/HeroTwo';
import img from '../assets/course-bg.png';
import enroll from '../assets/enroll.svg';
import axios from 'axios';
import { FlutterWaveButton, closePaymentModal } from 'flutterwave-react-v3';
import ReactDOM from "react-dom"

const PayPalButton = window.paypal.Buttons.driver("react", { React, ReactDOM });


const courses = ['Beginner Scratch Class', 'Intermediate Scratch Class', 'Advanced Scratch Class', 'Introduction to Python', 'Advanced Python class', 'Introduction to 3D Animation'

]

export default function Enrollment() {
  
  const [paypalPrice, setPaypalPrice] = useState(0);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [course, setCourse] = useState('');
  const [student, setStudent] = useState('');
  const [date, setDate] = useState('');
  
  const [country, setCountry] = useState('');
  
  console.log(
    name,email,phone,course, student, date, country
    )
    
    let initialStatus;
    const localPrice = ()=> {

    
    if(course === 'Beginner Scratch Class'){
      initialStatus = '20'
    }
    else if(course === "Intermediate Scratch Class"){
      initialStatus = '22500'
      // console.log('price is N15,000');
    }
    else if(course === "Advanced Scratch Class"){
      initialStatus = '30000'
      // console.log('price is N90,000');
    }
    else if(course === "Introduction to Python"){
      initialStatus = '25000'
      // console.log('price is N100,000');
    }
    else if(course === "Advanced Python class"){
      initialStatus = '25000'
      // console.log(`price is ${parseFloat(initialStatus)}`);
    }
    else if(course === "Introduction to 3D Animation"){
      initialStatus = '25000'
      // console.log('price is N900,000');
    }
    else{
      initialStatus = "0"
      // console.log('nothing selected')
    }

    setFlutterPrice(parseInt(initialStatus))

  }

  
  let internationalStatus;
    const InternationalPrice = ()=> {

    if(course === 'Beginner Scratch Class'){
      internationalStatus = '80'
    }
    else if(course === "Intermediate Scratch Class"){
      internationalStatus = '80'
      // console.log('price is N15,000');
    }
    else if(course === "Advanced Scratch Class"){
      internationalStatus = '100'
      // console.log('price is N90,000');
    }
    else if(course === "Introduction to Python"){
      internationalStatus = '120'
      // console.log('price is N100,000');
    }
    else if(course === "Advanced Python class"){
      internationalStatus = '150'
      // console.log(`price is ${parseFloat(initialStatus)}`);
    }
    else if(course === "Introduction to 3D Animation"){
      internationalStatus = '180'
      // console.log('price is N900,000');
    }
    else{
      internationalStatus = "0"
      // console.log('nothing selected')
    }

    setPaypalPrice(parseInt(internationalStatus))

  }


 
  const [flutterPrice, setFlutterPrice] = useState(0);

  const currentPrice =() => {
    InternationalPrice();
    localPrice();
  }

    console.log(flutterPrice)
    console.log(paypalPrice)   

    const createOrder = (data, actions) =>{
        return actions.order.create({
          purchase_units: [
            {
              amount: {
                value: paypalPrice,
              },
            },
          ],
        });
      };
    
      const onApprove = (data, actions) => {
        return actions.order.capture();
      };

    const handleSend = async (e) => {
        e.preventDefault();
        try{
            await axios.post("http://https://us-central1-chariscodingclub-a6025.cloudfunctions.net/app/enrollment_mail", {
                name,email,phone,course, student, date, country
            })
        }
        catch(error){
            console.log(error)
        }

        setName('')
        setEmail('')
        setPhone('')
        setCourse('')
        setDate('')
        setStudent('')
        setFlutterPrice(0)

    }

    const config = {
        public_key: process.env.REACT_APP_PUBLIC_KEY,
        tx_ref: Date.now(),
        amount: flutterPrice,
        currency: 'NGN',
        payment_options: 'card,mobilemoney,ussd',
        customer: {
          email: email,
          phonenumber: phone,
          name: name,
        },
        customizations: {
          title: 'Course Enrollment',
          description: `Payment for ${course}`,
          logo: 'https://st2.depositphotos.com/4403291/7418/v/450/depositphotos_74189661-stock-illustration-online-shop-log.jpg',
        },
      };
    
      const fwConfig = {
        ...config,
        text: 'Pay with Flutterwave!',
        callback: (response) => {
           console.log(response);
          closePaymentModal() // this will close the modal programmatically
        },
        onClose: () => {},
      };

     

    useEffect(() =>
    {
    axios.get(`https://api.iploka.com/check?api_key=${process.env.REACT_APP_KEY}`)
    .then(res=>{
        setCountry(res.data);
        setCountry(res.data['country_name']);
        
    })
    .catch((err) => {
        console.log(err);
    });
    

    }, []
    )

    

    function SubmitButton(){
        if (name && email && phone && course && student && date){
          return <button className='pri__btn' type="submit" ><FlutterWaveButton {...fwConfig} /></button>
        } else {
          return <button className='disabled' type="submit" disabled> Pay with Flutterwave </button>
        };
      };


      function PaypalSubmit (){
        if (name && email && phone && course && student && date){
            return  <PayPalButton
            createOrder={(data, actions) => createOrder(data, actions)}
            onApprove={(data, actions) => onApprove(data, actions)}
         />
          } else {
            return <button className='disabled'  type="submit" disabled> Pay with Paypal </button>
          }; 
      }
    return (
        <div>
            <HeroTwo 
         head='Enrollment'
         image={img}
         bgposition='top'
         bgsize='contain'
         />

        <div className="enrollment__main">
    

            <h2 className="head__two"> Course Enrollment Form </h2>

            <div className="form__main">
   
   <form onSubmit={handleSend} method="post" >
       <div className="form__group">
           <div className="form__body form__course">
              <label htmlFor=""> Full Name</label>
              <input type="text" value={name} placeholder="Type your full name..." onChange={e => setName(e.target.value)} required/>
          </div>
          

      </div>
      <div className="form__group">
          <div className="form__body">
              <label htmlFor="" > Email </label>

              <input type="email" value={email} placeholder="Enter your email address..." onChange={e => setEmail(e.target.value)}  required/>
          </div>
          <div className="form__body">
              <label htmlFor=""> Phone Number </label>

              <input type="number" value={phone} placeholder="Enter your email address..." onChange={e => setPhone(e.target.value)} required />
          </div>
      </div>
      <label htmlFor=""> Country </label>

      <input type="text" value={country} disabled placeholder={country}  />
      <div className="form__body form__course">
             <label htmlFor=""> Courses </label>
                    <select name="courses"  onChange={(e) => setCourse(e.target.value)} value={course} onClick={currentPrice}>
                            <option value="">Select your Course</option>
                            {courses.map((name) => (
                            <option key={name.value} value={name.value}>
                                {name}
                            </option>
                            ))}
                    </select>
                    
                </div>
                <div className="form__body form__course">
                     
                     <label htmlFor=""> Student Name </label>
                     <input type="text" value={student} placeholder="Type the name of student..." onChange={(e) => setStudent(e.target.value)} required />
 
                     <label htmlFor=""> Date of Birth </label>
                     <input type="date" value={date} placeholder="Type the number of children..." onChange={(e) => setDate(e.target.value)} required />
                     <label htmlFor=""> Sub Total </label>
 
                     <input type="text"  name="total" disabled placeholder={parseFloat(flutterPrice)} value={country ==='Nigeria' ? `₦ ${flutterPrice.toLocaleString()}` : `$ ${paypalPrice}`} />
                 </div>
      { country ==='Nigeria' ?
      <SubmitButton/> :
      <PaypalSubmit />
}
   </form>
   </div>

           {/* {currentPage=== 1 && (
                <FormOne {...wizard} onSubmit={nextPage} />
                )}
                {currentPage=== 2 && (
                <FormTwo
                    {...wizard}
                    prevPage={prevPage}
                    onSubmit={nextPage}
                />
            )} 
                {currentPage=== 3 && (
                <FormThree
                    {...wizard}
                    prevPage={prevPage}
                    onSubmit={onSubmitWizard}
                />
            )}  */}
     </div>
        </div>
    )
}
